import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import sizeStyles from './style/size.css';
import colorStyles from './style/color.css';

const paragraphStyles = { ...sizeStyles, ...colorStyles };
const cx = classNames.bind(paragraphStyles);

/**
 * The heading component provides a quick way to style any heading with a font
 * size from our typography scale, color from our color palette and a HTML tag
 * of choice.
 */
export default function Paragraph({ children, size, color, id, tag }) {
  const CustomTag = tag;
  const paragraphProps = {
    className: cx(size, color),
    id,
  };
  return <CustomTag {...paragraphProps}>{children}</CustomTag>;
}

Paragraph.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  color: PropTypes.oneOf([
    'black',
    'steel',
    'slate',
    'silver',
    'smoke',
    'darkSmoke',
    'extraDarkSmoke',
    'snow',
    'darkSnow',
    'extraDarkSnow',
    'white',
    'green',
    'red',
    'blue',
  ]),
  id: PropTypes.string,
  size: PropTypes.oneOf(['xxxl, xxl, xl, l, m, s, xs']),
  tag: PropTypes.oneOf(['div', 'span', 'p']),
};

Paragraph.defaultProps = {
  color: 'black',
  size: 'm',
  tag: 'p',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-paragraph/Paragraph/index.js